import { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../../config/supabase'
import './Auth.css'

function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setSuccess(false)
    setLoading(true)

    try {
      // Validar formato de email antes de enviar
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(email.trim())) {
        setError('Please enter a valid email address.')
        setLoading(false)
        return
      }

      // Obtener la URL base para la redirección
      const redirectTo = `${window.location.origin}/reset-password`
      
      console.log('🔵 Enviando solicitud de reset de contraseña para:', email.trim())
      console.log('🔵 URL de redirección:', redirectTo)
      console.log('🔵 Origin completo:', window.location.origin)
      
      const { data, error: resetError } = await supabase.auth.resetPasswordForEmail(email.trim(), {
        redirectTo: redirectTo,
      })

      if (resetError) {
        console.error('❌ Error completo de Supabase:', resetError)
        console.error('❌ Código de error:', resetError.code)
        console.error('❌ Mensaje:', resetError.message)
        console.error('❌ Status:', resetError.status)
        console.error('❌ Detalles completos:', JSON.stringify(resetError, null, 2))
        
        // Manejar errores específicos
        if (resetError.status === 400) {
          // Error 400 - Bad Request
          if (resetError.message?.includes('redirect_to') || resetError.message?.includes('redirect')) {
            throw new Error('Configuration error: The redirect URL is not allowed. Please contact the administrator.')
          } else if (resetError.message?.includes('email')) {
            throw new Error('Invalid email. Please check that the email address is correct.')
          } else {
            throw new Error(`Error sending email: ${resetError.message || 'Please check your Supabase configuration.'}`)
          }
        } else if (resetError.message?.includes('rate limit') || resetError.message?.includes('too many')) {
          throw new Error('Too many attempts. Please wait a few minutes before trying again.')
        } else if (resetError.message?.includes('not found') || resetError.message?.includes('does not exist')) {
          // Por seguridad, no revelar si el email existe o no
          console.warn('⚠️ Email no encontrado en la base de datos')
          // Mostrar mensaje genérico de éxito
          setSuccess(true)
          return
        }
        throw resetError
      }

      console.log('✅ Solicitud de reset enviada exitosamente:', data)
      setSuccess(true)
    } catch (err) {
      console.error('❌ Error completo:', err)
      setError(err.message || 'Error sending reset email. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <p className="auth-welcome-text">
          Forgot your password? No worries. Enter your email address and we'll send you a link to reset it.
        </p>
        
        {success ? (
          <div className="success-message">
            <h2>Check your email!</h2>
            <p>
              We've sent a password reset link to <strong>{email}</strong>. 
              Please check your inbox and click the link to reset your password.
            </p>
            <p style={{ marginTop: '1rem', fontSize: '0.9rem', opacity: 0.8 }}>
              Didn't receive the email? Check your spam folder or try again.
            </p>
            <Link to="/login" className="auth-link" style={{ display: 'inline-block', marginTop: '1.5rem' }}>
              Back to Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="email">Email address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email"
              />
            </div>

            {error && (
              <div className="error-message">{error}</div>
            )}

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <p className="auth-footer-text">
              Remember your password? <Link to="/login" className="auth-link">Sign In</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  )
}

export default ForgotPassword
